"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.25234 0.503906H14.7438C15.4304 0.503906 15.9961 1.07734 15.9961 1.76406V2.13867L8.28281 6.31719C8.28086 6.31719 8.27891 6.31836 8.27695 6.31953C8.2751 6.32031 8.27314 6.32109 8.27119 6.32109C8.10732 6.41875 7.90049 6.41875 7.73272 6.32109C7.72998 6.32109 7.72529 6.31914 7.72139 6.31797L7.71719 6.31719L0 2.13867V1.76406C0 1.07734 0.565723 0.503906 1.25234 0.503906Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0 3.02422L7.33867 7.00391C7.74443 7.23398 8.25166 7.23398 8.65742 7.00391L16 3.02422V11.5723C16 12.259 15.4343 12.8324 14.7477 12.8324H1.25234C0.565723 12.8324 0 12.259 0 11.5723V3.02422Z",
    fill: fill
  }));
};

exports["default"] = _default;